import { api } from "@/api";
import {
  AddLeagueMappingParams,
  LeagueProviderMappingDto,
} from "@/types/ApiResponses/League";

export const addLeagueMapping = async (
  params: AddLeagueMappingParams
): Promise<LeagueProviderMappingDto> => {
  const { leagueId, ...body } = params;
  const res = await api.client.post(`/leagues-new/${leagueId}/mappings`, body);
  return res.data;
};
